import { render, staticRenderFns } from "./drawConfig.vue?vue&type=template&id=20a6e17d&"
import script from "./drawConfig.vue?vue&type=script&lang=js&"
export * from "./drawConfig.vue?vue&type=script&lang=js&"
import style0 from "./drawConfig.vue?vue&type=style&index=0&id=20a6e17d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports